import Seo from "@/components/Seo";
import CalendlyInline from "@/components/CalendlyInline";
import { Eyebrow, Reveal, Section } from "@/components/Primitives";
import { SITE, waLink } from "@/lib/data";

export default function Contact() {
    return (
        <>
            <Seo
                title="Contact"
                description="Book a discovery call with Phoebus AI. Working hours 9am to 6pm GST. Email sales@phoebusai.com or reach us on WhatsApp."
                path="/contact"
            />

            <Section className="pt-16 md:pt-24">
                <Reveal>
                    <Eyebrow>Contact</Eyebrow>
                    <h1 className="mt-6 font-display font-black tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.05] max-w-3xl">
                        Book a discovery call
                    </h1>
                    <p className="mt-6 text-lg text-pa-ink-500 max-w-2xl">
                        A 1–2 week discovery maps how your team works today and
                        defines the automation opportunity — before you commit
                        to any build.
                    </p>
                </Reveal>

                <div className="mt-14 grid gap-10 lg:grid-cols-[1fr_1.2fr] lg:gap-16">
                    {/* Left: details */}
                    <div className="space-y-8">
                        <Reveal>
                            <div className="border-l-2 border-pa-blue-600 pl-5">
                                <div className="font-mono text-xs uppercase tracking-widest text-pa-ink-500">
                                    Availability
                                </div>
                                <div className="mt-1 font-display text-2xl font-bold">
                                    Working hours: {SITE.hours}
                                </div>
                            </div>
                        </Reveal>

                        <Reveal delay={0.05}>
                            <div className="space-y-5">
                                <a
                                    href={waLink(
                                        "Hi Phoebus AI — I'd like to book a discovery call about AI automation.",
                                    )}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="contact-whatsapp"
                                    className="group flex items-center justify-between gap-4 bg-pa-blue-600 text-white p-5 cut-tr hover:bg-pa-blue-700 transition-colors"
                                >
                                    <span>
                                        <span className="block font-mono text-xs uppercase tracking-widest text-white/70">
                                            WhatsApp
                                        </span>
                                        <span className="block font-display text-xl font-bold">
                                            {SITE.phone}
                                        </span>
                                    </span>
                                    <span className="transition-transform group-hover:translate-x-1">
                                        →
                                    </span>
                                </a>

                                <a
                                    href={`mailto:${SITE.email}`}
                                    data-testid="contact-email"
                                    className="group flex items-center justify-between gap-4 border border-pa-line p-5 cut-tr hover:border-pa-blue-600 transition-colors"
                                >
                                    <span>
                                        <span className="block font-mono text-xs uppercase tracking-widest text-pa-ink-500">
                                            Email
                                        </span>
                                        <span className="block font-display text-xl font-bold">
                                            {SITE.email}
                                        </span>
                                    </span>
                                    <span className="transition-transform group-hover:translate-x-1 text-pa-blue-700">
                                        →
                                    </span>
                                </a>
                            </div>
                        </Reveal>

                        <Reveal delay={0.1}>
                            <div className="border-t border-pa-line pt-6">
                                <div className="font-mono text-xs uppercase tracking-widest text-pa-ink-500">
                                    {SITE.entity}
                                </div>
                                <p className="mt-2 text-pa-ink-500 max-w-sm">
                                    {SITE.address}
                                </p>
                                <div className="mt-4 flex gap-5">
                                    <a
                                        href={SITE.linkedin}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="font-mono text-sm text-pa-blue-700 hover:text-pa-blue-600"
                                    >
                                        LinkedIn
                                    </a>
                                    <a
                                        href={SITE.facebook}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="font-mono text-sm text-pa-blue-700 hover:text-pa-blue-600"
                                    >
                                        Facebook
                                    </a>
                                </div>
                            </div>
                        </Reveal>
                    </div>

                    {/* Right: lazy calendar */}
                    <Reveal delay={0.08}>
                        <div className="border border-pa-line cut-tr-lg overflow-hidden bg-pa-blue-050 flex flex-col">
                            <div className="p-5 border-b border-pa-line bg-white flex items-center justify-between">
                                <span className="font-display text-lg font-bold">
                                    Pick a time
                                </span>
                                <span className="font-mono text-xs uppercase tracking-widest text-pa-ink-500">
                                    {SITE.hours}
                                </span>
                            </div>
                            <CalendlyInline
                                url={SITE.calendarUrl}
                                className="h-[640px] w-full"
                            />
                            <div className="p-4 border-t border-pa-line bg-white text-center">
                                <a
                                    href={SITE.calendarUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="font-mono text-sm text-pa-blue-700 underline underline-offset-4 hover:text-pa-blue-600"
                                >
                                    Calendar not loading? Open the scheduling page →
                                </a>
                            </div>
                        </div>
                    </Reveal>
                </div>
            </Section>
        </>
    );
}
